import { breakSettings, refreshSlider } from "@grindex-client/components/Slider/slider";

import ContentDetailPageElements from "./contentDetailPage.dom";

function init($views) {
	const $view = $views[0];
	const dom = new ContentDetailPageElements($view);
	const $sliders = dom.sliders();

	$sliders.forEach((slider) => {
		var uptime = slider.dataset.pause;
		var isFlippableCardSlider = slider.children.length > 1 && dom.flippableCard(slider).length > 0;

		if (!isFlippableCardSlider) {
			var timeout = window.setTimeout(() => {
				$(slider).bxSlider({
					auto: true,
					breaks: breakSettings.largeCardBreakSettings,
					pager: false,
					slideMargin: 20,
					pause: uptime ? uptime * 1000 : 5000,
					autoHover: true,
					autoReload: false,
					onSliderRedraw: () => {
						refreshSlider(slider);
					},
				});

				clearTimeout(timeout);
			}, 300);
		}
	});
}

export default {
	view: "contentDetailPage",
	init,
};
